import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    icon: '📘',
    title: 'TOMO 1 — ChatGPT: El Cerebro Ejecutivo',
    color: 'from-green-500/20 to-green-500/5',
    borderColor: 'border-green-500/30',
    textColor: 'text-green-400',
    desc: 'Con este tomo vas a dejar de obtener respuestas genéricas y empezar a producir textos, correos y contenido profesional en minutos. Vas a dominar el arte de pedir bien para recibir exactamente lo que necesitás, sin desperdiciar consultas ni tiempo.',
    pages: '30 páginas. Cero relleno. Todo ejecutable desde hoy.'
  }, {
    icon: '📗',
    title: 'TOMO 2 — DeepSeek: El Cerebro Analítico',
    color: 'from-purple-500/20 to-purple-500/5',
    borderColor: 'border-purple-500/30',
    textColor: 'text-purple-400',
    desc: 'Con este tomo vas a tomar mejores decisiones de negocio usando datos reales, sin ser contador ni programador. Vas a analizar precios, márgenes y estrategias con una IA que razona como un consultor y es 100% gratuita.',
    pages: '30 páginas. Razonamiento aplicado al negocio real.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — Claude: El Cerebro Creativo',
    color: 'from-orange-500/20 to-orange-500/5',
    borderColor: 'border-orange-500/30',
    textColor: 'text-orange-400',
    desc: 'Con este tomo vas a producir textos que suenan humanos, persuasivos y con tu propia voz, sin que nadie sospeche que usaste IA. Vas a escribir más rápido, con mejor calidad y con un estilo que te diferencia de la competencia.',
    pages: '30 páginas. Redacción de autor aplicada al negocio.'
  }];
  const features = ['Sistema paso a paso listo para implementar hoy', 'Prompts reales probados, no genéricos de internet', 'Comparativas de uso correcto vs. incorrecto', 'Ejemplos adaptados al mercado hispanohablante', '100% ejecutable con versiones gratuitas de cada IA', 'Glosario técnico en español neutro'];
  return <section className="py-20 bg-dark" data-id="element-269">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white" data-id="element-272">
            🤖 3 TOMOS COMPLETOS — De cero a profesional
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-273">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className={`rounded-2xl border ${tomo.borderColor} bg-gradient-to-b ${tomo.color} p-8 flex flex-col h-full`} data-id="element-274">
              <div className="text-4xl mb-4" data-id="element-275">{tomo.icon}</div>
              <h3 className={`text-xl font-bold mb-4 ${tomo.textColor}`} data-id="element-276">
                {tomo.title}
              </h3>
              <p className="text-gray-300 mb-6 flex-grow leading-relaxed" data-id="element-277">
                {tomo.desc}
              </p>
              <div className="pt-4 border-t border-white/10 mt-auto" data-id="element-278">
                <p className="text-sm font-bold text-white" data-id="element-279">{tomo.pages}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass-card rounded-2xl p-8 max-w-4xl mx-auto" data-id="element-280">
          <h4 className="text-xl font-bold text-center mb-8 text-white" data-id="element-281">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-282">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-283">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0" data-id="element-284" />
                <span className="text-gray-300" data-id="element-285">{feature}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}